import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Modal } from 'antd'
import { clsx } from 'clsx'

import { DeleteBorderlessIcon, DeleteIcon } from '@/components/Icons'
import { useAppDispatch } from '@/store/hook'
import { removeCartItem } from '@/store/slices/cartSlice'
import { useDeviceDetect } from '@/hooks'

const { confirm } = Modal

interface RemoveCartItemProps {
  materialNumber?: string | React.ReactElement
  haveText?: boolean
  isOnFlexStart?: boolean
  wrapperClassname?: string | null
  buttonClassname?: string | null
  style?: React.CSSProperties
}

function RemoveCartItem({
  materialNumber = '',
  haveText = true,
  isOnFlexStart = false,
  wrapperClassname = null,
  buttonClassname = null,
  ...rest
}: RemoveCartItemProps) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { isMobile } = useDeviceDetect()

  const wrapperClasses = clsx(
    'remove-cart-item__wrapper',
    {
      'justify-start': isOnFlexStart,
    },
    [wrapperClassname],
  )
  const buttonClasses = clsx('remove-cart-item--btn', [buttonClassname])

  const handleDelete = (e, materialNumber_) => {
    e.stopPropagation()

    dispatch(removeCartItem(materialNumber_))
  }

  const showDeleteConfirm = (e) => {
    e.stopPropagation()

    confirm({
      title: t('cart.modal.title'),
      content: t('cart.modal.content'),
      okText: t('cart.modal.confirmBtn'),
      okType: 'danger',
      cancelText: t('cart.modal.cancelBtn'),
      onOk() {
        handleDelete(e, materialNumber)
      },
    })
  }

  return (
    <div className={wrapperClasses}>
      <button
        {...rest}
        className={buttonClasses}
        type="button"
        onClick={typeof materialNumber === 'string'
          ? (e) => showDeleteConfirm(e)
          : (e) => handleDelete(e, materialNumber)}
      >
        {isMobile
          ? <DeleteIcon className="remove-cart-item__icon" />
          : <DeleteBorderlessIcon className="remove-cart-item__icon" />}
        {haveText && <span>{t('cart.removeItem')}</span>}
      </button>
    </div>
  )
}

export default RemoveCartItem
